import React, { FC, useEffect, useState } from "react"
import Breadcrumb from "../../../components/common/Breadcrumbs";
import { useFindUserSettingsByGroupNameQuery } from "../../../components/common/userSetting/userSettingsApi";
import { SearchSelectWithList } from "../../../components/common/datatable/filter/SearchSelectWrapper";
import { DataTable } from "../../../components/common/datatable/DataTable";
import {
    useLazyExportBillReleaseDataQuery, useSearchBillReleasesQuery
} from "./billReleaseApi";
import { useGetAllStatesQuery } from "../states/statesApi";
import IconButton from "../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { useGetAllTenantsQuery } from "../../customer/tenantApi";
import { SearchInputWrapper } from "../../../components/common/datatable/filter/SearchInputWrapper";
import {
    createClickableLink,
    SearchSelectWithIndeterminateBoolean
} from "../../../components/common/datatable/DataTableUtils";
import { getBooleanDisplayIcon, getStateValueFromParam } from "../../../helpers/utils/Utils";
import { useLazyGetAllCountyByStateAbbrQuery } from "../counties/countiesApi";

const BillReleases: FC = () => {

    const navigate = useNavigate()

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Bill Release", url: "" },
    ])

    useEffect(() => {
        document.title = "Bill Releases";
    });

    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("Bill Release");
    const stateData = useGetAllStatesQuery("");
    const tenantData = useGetAllTenantsQuery("");
    const [triggerExportBillReleaseDataQuery] = useLazyExportBillReleaseDataQuery();
    const [getAllCountyByStateAbbrApi, getAllCountyByStateAbbrApiResponse] = useLazyGetAllCountyByStateAbbrQuery()
    const state = getStateValueFromParam(window);


    useEffect(() => {
        getAllCountyByStateAbbrApi(state);
    }, [state]);
    const columns: DataTableColumn[] = [

        {
            label: "State", accessor: "county.state.stateName", visibility: {
                canColumnShow: false
            },
            filterOptions: [{
                dependentColumns: ["County"],
                filterComponent: SearchSelectWithList(stateData?.data, "stateName", "stateAbbreviation", "Select State...", false, "state"),
                overrideFilterAccessor: "state"
            }],
        },

        {
            label: "County", accessor: "county.countyName", visibility: {
            },
            cell: (props: any) => {
                let path = "/bill-release/" + props.row.original.id;
                return createClickableLink(path, props.row.original?.county?.countyName + "," + props.row.original?.county?.state?.stateAbbreviation, userSettings, false, "", ["BILLREL-R"]);
            },
            filterOptions: [{
                filterComponent: SearchSelectWithList(getAllCountyByStateAbbrApiResponse?.data, "countyName", "id", "Select counties...", true, "countyIds"),
                onDependencyUpdated: (value: string) => {
                    getAllCountyByStateAbbrApi(value);
                },
                overrideFilterLabel: "Counties",
                overrideFilterAccessor: "countyIds"
            }],
        },

        {
            label: "Tenant",
            accessor: "tenant",
            visibility: {
                hasShowSetting: false,
                disallowedCustomerLevels: ["TENANT"]
            },
            filterOptions: [{
                filterComponent: SearchSelectWithList(tenantData?.data, "name", "name", "Select Tenant...", false, "tenant"),
                overrideFilterAccessor: "tenant",
                overrideFilterLabel: "Tenant",
            }],
        },

        {
            label: "Tax Year", accessor: "taxYear",
            visibility: {
                hasShowSetting: false,
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"number"} placeholder={"Enter Tax Year..."}
                    accessor={"taxYear"} />,
                overrideFilterLabel: "Tax Year",
                overrideFilterAccessor: "taxYear"
            }],
        },


        {
            label: "Is Released", accessor: "released", cell: (props: any) => getBooleanDisplayIcon(props.value, "Enabled", "Disabled"),
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Select Is Released...", "released"),
                overrideFilterAccessor: "released",
                overrideFilterLabel: "Is Released",
            }]
        },
        {
            label: "Note", accessor: "note",
            cell: (props: any) => {
                return <>
                    <div title={props.value} className="max-w-[200px]  whitespace-nowrap">
                        {props.value?.length > 70 ? props.value?.substring(0, 70) + "..." : props.value}
                    </div>
                </>
            },
        }
    ]

    return (

        <div className="user-container px-4 py-2">

            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchBillReleasesQuery,
                    exportAction: triggerExportBillReleaseDataQuery
                }}
                userSettingGroup={"Bill Release"}
                defaultSortOptions={{
                    accessor: "county.countyName",
                    direction: "asc"
                }}
                defaultFilter={{
                    state:"TX"
                }}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/bill-release/create")
                            }}
                            title={"Add Bill Release"}
                        />,
                        permissions: ["BILLREL-C"]
                    },
                }}
                basePermission={"BILLREL"}
            />

        </div>

    )
}
export default BillReleases